import { render, staticRenderFns } from "./Timerecorder.vue?vue&type=template&id=b6118af0&"
import script from "./Timerecorder.vue?vue&type=script&lang=js&"
export * from "./Timerecorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports